import moment from "moment";
export default {
  methods: {
    decimalFormatter: function(value) {
      return value.replace(/[^-?\d.]/g, "").replace(/(\..*)\./g, "$1");
    },
    positiveDecimalFormatter: function(value) {
      return value.replace(/[^\d.]/g, "").replace(/(\..*)\./g, "$1");
    },
    integerFormatter: function(value) {
      return value.replace(/[^0-9]/g, "").replace(/(\..*)\./g, "$1");
    },

    dateFormatter: function(
      date,
      output_format = "DD MMM YYYY",
      input_format = "YYYY-MM-DD"
    ) {
      if (date == null) return '';
      moment.locale(localStorage.getItem("user_language") || window.navigator.language || "es");
      return moment(date, input_format)
        .format(output_format)
        .split(" ")
        .map(v => v[0].toUpperCase() + v.substr(1).replace(".", ""))
        .join(" ");
    },

    dateFormatterDayMonthName: function(date) {
      return this.dateFormatter(date, "DD MMM");
    },

    dateFormatterYearMonthDay: function(date) {
      return this.dateFormatter(date, "YYYY-MM-DD");
    },

    dateFormatterWeek: function(date) {
      return moment(date).week();
    },

    getFormatCurrency: function(amount) {
      return amount.toLocaleString("es-PE", {
        style: "currency",
        currency: "pen",
        minimumFractionDigits: 1
      });
    },

    getFormatNumber: function(amount, digits = 0) {
      digits = amount % 1 == 0 ? 0 : digits;
      return amount.toLocaleString("es-PE", {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      });
    },

    getFormatBytes: function (bytes, decimals = 2) {
      if (!bytes) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },

    numberWithPrecision: function (number, precision) {
      if (number === undefined || number === null) return;

      number = Number(number.toString());
      let dec = String(number).split(".");
      let decimales = dec.length > 1 ? dec.pop() : ''

      precision = decimales.length < precision ? decimales.length : precision;

      const formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision
      });

      return formatter.format(number);
    },

    currencyMoney(money, symbol = "", currency_singular = "", currency_plural = "") {
      let number = this.numberWithPrecision(money) || 0
      return `${symbol} ${number} ${money == 1 ? currency_singular : currency_plural}`;
    },

    removeTimeZoneToDate: function (date) {
      if (!date) return null;
      let parsed_date = date?.split(".")[0];
      return parsed_date;
    },
    daysUntilExpirationDate(expiration_date) {
      return moment(expiration_date).diff(moment.now(), "days");
    },
  }
};
